import { motion } from "framer-motion";
import { IMAGES } from "@/lib/api";

const editions = [
  {
    tag: "Edition 01",
    name: "The Slim",
    img: IMAGES.productAngle,
    desc: "A rounded, pen-style stylus that rests in a side channel. Familiar grip, natural writing feel \u2014 for those who sketch and annotate all day.",
    specs: ["Round pen profile", "Side-channel dock", "Warm titanium finish"],
  },
  {
    tag: "Edition 02",
    name: "The Flat",
    img: IMAGES.flatPrototype,
    desc: "An ultra-thin flat stylus that magnetically snaps into the back of the case. Truly flush, truly invisible \u2014 always with you, never in the way.",
    specs: ["Flat lozenge profile", "Magnetic back-snap", "Matte stealth black"],
  },
];

export const Prototypes = () => (
  <section id="prototypes" data-testid="prototypes-section" className="py-24 md:py-32 bg-stone-100/50 border-y border-stone-200">
    <div className="max-w-7xl mx-auto px-6 md:px-10">
      <div className="max-w-2xl mb-16">
        <p className="text-xs tracking-[0.25em] uppercase font-bold text-stone-500 mb-6">Two prototypes</p>
        <h2 className="font-serif text-4xl md:text-6xl tracking-tight leading-tight text-stone-900">
          One obsession, <span className="italic">two forms.</span>
        </h2>
        <p className="mt-6 text-lg text-stone-600">
          Choose the stylus that fits how you work. Same seamless philosophy, two distinct designs.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-6">
        {editions.map((e, i) => (
          <motion.div
            key={e.name}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: i * 0.1 }}
            data-testid={`prototype-${i}`}
            className="rounded-3xl bg-white border border-stone-200 overflow-hidden hover:border-stone-300 transition-colors"
          >
            <div className="bg-stone-100 flex items-center justify-center p-8">
              <img src={e.img} alt={e.name} className="h-72 w-auto object-contain rounded-2xl" />
            </div>
            <div className="p-8 md:p-10">
              <p className="text-xs tracking-[0.25em] uppercase font-bold text-stone-400 mb-3">{e.tag}</p>
              <h3 className="font-serif text-3xl md:text-4xl text-stone-900 mb-4">{e.name}</h3>
              <p className="text-stone-600 leading-relaxed mb-6">{e.desc}</p>
              <div className="flex flex-wrap gap-2">
                {e.specs.map((s) => (
                  <span key={s} className="text-xs font-medium text-stone-600 bg-stone-100 border border-stone-200 rounded-full px-3 py-1.5">
                    {s}
                  </span>
                ))}
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
